import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder for the `/developments` list page.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentsRoute = defineRoute("/developments");
